import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';

const AnimPending = (vAlign = false) => (
  <div className={vAlign ? 'pos-abs-center' : 'text-center'}>
    <FA icon={faSpinner} fixedWidth pulse />
  </div>
);

export default AnimPending;
